<template>
  <nav class="content-footer">
    <div class="btn-group d-flex content-btn-group" role="group" aria-label="...">
      <button type="button" class="btn btn-secondary btn-lg btn-pager btn-fw-2" onclick="location.href='#'" 
        @click="goBack" v-text="$props.footer.back"></button>
      <button type="button" class="btn btn-primary btn-lg btn-pager btn-fw-2" onclick="location.href='#'" 
        @click="goNext" v-text="$props.footer.next"></button>
    </div>
  </nav>
</template>

<script>
export default {
  props: [
    'footer',
  ],
    methods: {
        goBack: function() { this.$emit('goback'); },
        goNext: function() { this.$emit('gonext'); }
    },
}
</script>

<style>
.content-footer {
  margin-bottom: 50px;
}

.content-btn-group {
  width: 80%;
  margin: auto;
}

</style>